export default ListagemController;

import * as _ from 'lodash';

/** @ngInject */
function ListagemController($state, Empresas, Fretes) {

  let vm = this;

  vm.buscarEmpresas = buscarEmpresas;
  vm.buscarMaisEmpresas = buscarMaisEmpresas;
  vm.abrirDetalhamento = abrirDetalhamento;

  vm.infiniteScroll = {
    busy: false,
    finished: false,
    empresas: Empresas.obterEmpresasCache()
  };

  Empresas.tabIndex = 0;
  Fretes.setarCacheId('empresas');
  Fretes.limparCache();

  function buscarEmpresas(offset) {
    let filtro = {
      nome: Empresas.filtro.nome,
      local: _.pick(Empresas.filtro.local, ['id_tipo', 'cd_cidade_uf']),
      limit: Empresas.LIMIT,
      offset: offset || 0
    };

    vm.infiniteScroll.busy = true;

    if (!offset) {
      vm.infiniteScroll.empresas.splice(0);
    }

    return Empresas.buscarEmpresas(filtro)
      .then(empresas => {
        if (!offset) {
          vm.infiniteScroll.finished = false;
          vm.infiniteScroll.empresas = empresas;
        } else {
          for (let empresa of empresas) {
            vm.infiniteScroll.empresas.push(empresa);
          }
        }

        vm.infiniteScroll.busy = false;
        vm.infiniteScroll.finished = empresas.length !== Empresas.LIMIT;

        return empresas;
      })
      .catch(() => vm.infiniteScroll.finished = !(vm.infiniteScroll.busy = false));
  }

  function buscarMaisEmpresas() {
    var length = vm.infiniteScroll.empresas.length;

    if ($state.is('consulta.empresas.listagem') && !(length % Empresas.LIMIT)) {
      return buscarEmpresas(length);
    }
  }

  function abrirDetalhamento(empresa) {
    $state.go('consulta.empresas.detalhe', empresa);
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/empresas/listagem.controller.ts
 **/